/**
 * Calculates 95% of the specified value.
 */
export function value95percent(value: number): number {
  return Math.ceil(value * 0.95);
}
